// src/lib/inbox-media.js — Lot photos Messagerie (décision Dimitri 2026-07-09).
//
// Les messages photo Airbnb/Booking arrivent via Beds24 sous forme de fragment
// HTML BRUT dans le body texte (ex. `<a href="https://a0.muscache.com/im/
// pictures-signed/...jpeg?X-Amz-...">`) — jusqu'ici affiché tel quel.
//
// Ce module PUR (0 I/O, 0 DOM) extrait les URLs d'images des hôtes OTA en
// LISTE BLANCHE STRICTE et rend le texte restant propre. Le rendu <img> se
// fait côté ThreadDisplay. GARDE-FOUS :
//   • liste blanche d'hôtes UNIQUEMENT (muscache.com = Airbnb, bstatic.com =
//     Booking) — jamais d'<img> vers un hôte arbitraire (pixel espion) ;
//   • https uniquement ;
//   • AUCUNE interprétation HTML générale (pas de dangerouslySetInnerHTML côté
//     rendu — on parse vers des éléments React) ;
//   • le body STOCKÉ n'est jamais modifié (affichage seul — copilote IA,
//     recherche et exports lisent toujours le brut).
// NB : les URLs Airbnb sont SIGNÉES et expirent (X-Amz-…) — le rendu prévoit
// un fallback lien si l'image ne charge plus.

const OTA_IMAGE_HOST_RE = /(^|\.)((muscache)\.com|(bstatic)\.com)$/i;

// URL https capturée soit dans un href="…", soit nue dans le texte.
const HREF_RE = /<a\s+[^>]*href="(https:\/\/[^"]+)"[^>]*>(?:[^<]*<\/a>)?/gi;
const BARE_URL_RE = /https:\/\/[^\s"'<>]+/gi;

function isWhitelistedImageUrl(raw) {
  try {
    const u = new URL(raw);
    if (u.protocol !== "https:") return false;
    return OTA_IMAGE_HOST_RE.test(u.hostname);
  } catch (_) {
    return false;
  }
}

/**
 * Extrait les images OTA d'un body de message.
 * @param {string} body — body BRUT stocké (jamais modifié en base).
 * @returns {{ images: string[], text: string }} — URLs liste-blanche (ordre
 *   d'apparition, dédupliquées) + texte restant nettoyé (fragments <a> et
 *   URLs image retirés, espaces repliés).
 */
export function extractOtaImages(body) {
  if (!body || typeof body !== "string") return { images: [], text: body || "" };
  const images = [];
  let text = body;

  // 1) Fragments <a href="…">…</a> (forme réelle des photos Airbnb via Beds24).
  text = text.replace(HREF_RE, (frag, url) => {
    if (isWhitelistedImageUrl(url)) {
      if (!images.includes(url)) images.push(url);
      return " ";
    }
    return frag; // hôte hors liste blanche → fragment laissé tel quel (honnête)
  });

  // 2) URLs nues d'hôtes liste blanche.
  text = text.replace(BARE_URL_RE, (url) => {
    if (isWhitelistedImageUrl(url)) {
      if (!images.includes(url)) images.push(url);
      return " ";
    }
    return url;
  });

  // Nettoyage : espaces multiples et lignes vides résiduelles.
  text = text.replace(/[ \t]{2,}/g, " ").replace(/\n{3,}/g, "\n\n").trim();
  return { images, text };
}
